import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { MatAutocompleteTrigger } from '@angular/material';

import {
  AutocompleteOption, AutocompleteOptionType,
  AutocompleteTriggerComponent
} from '../autocomplete-trigger/autocomplete-trigger.component';
import { SearchQuery } from '../../search/models/search-query.model';
import { AutocompleteOverlayComponent } from '../autocomplete-overlay/autocomplete-overlay.component';
import { browser } from '../../../browser';
import { Source } from '../models/source.model';


@Component({
  selector: 'app-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss'],
  host: { 'class': 'autocomplete' }
})
export class AutocompleteComponent {
  query: string;
  searchCtrl: FormControl;

  @ViewChild('queryField', { read: MatAutocompleteTrigger }) acInputTrigger: MatAutocompleteTrigger;
  @ViewChild('acTrigger', { read: AutocompleteTriggerComponent }) acTrigger: AutocompleteTriggerComponent;
  @ViewChild('acOverlay') acOverlay: AutocompleteOverlayComponent;

  constructor(
    private _router: Router,
    private _cdref: ChangeDetectorRef
  ) {
    this.searchCtrl = new FormControl();
  }

  onItemSelected (e: AutocompleteOption) {
    switch (e.type) {
      case AutocompleteOptionType.Airport:
        if (e.airport.sourceId === Source.CaribbeanGuide || e.airport.sourceId === Source.BahamasGuide) {
          this._router.navigate(['/airports',  e.airport.identifier, 'island']);
        } else {
          this._router.navigate(['/airports', e.airport.identifier]);
        }
        break;
      case AutocompleteOptionType.Location:
        break;
      default:
        const query = new SearchQuery();
        query.term = e.query;
        const params = query.encode();
        this._router.navigate(['/search'], { queryParams: params });
    }
    this.searchCtrl.setValue('');
  }

  onQueryFocus(e: Event) {
    if (browser && (browser.os === 'iOS' || browser.os === 'Android OS')) {
      // Angular Material's autocomplete component is not really usable on mobile:
      // https://github.com/angular/material2/issues/6341
      //
      // Instead, pop up a full-screen overlay with a search box and a filtered list of suggestions
      e.preventDefault();
      this.acOverlay.show();
      this._cdref.detectChanges();
      this.acOverlay.focus();
    }
  }

  onSubmit() {
    const query = new SearchQuery();
    query.term = this.query;
    this.acTrigger.submit(query);
    this.acInputTrigger.closePanel();
    this.searchCtrl.setValue('');
  }
}
